import { ContentWrapper, DataTable } from "@components/index";
import { Col, Input, Pagination, Row, Select, Space, Spin, TableColumnsType, Tabs, Tooltip, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { get } from "@services/api.service";
import { useNotification } from "@hooks/useNotification";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { useMaskId } from "~/Hooks/useMaskId";
import { useHasAccess } from "@hooks/useHasAccess";
import { getColoriezedValue, getColorizedValueDocuSign } from "~/Utils/getColorizedValue";
import { useQuery } from "~/Hooks/useQuery";
import { useAuth } from "@hooks/useAuth";
import { getFormattedDate, getUrlwithParams, hasKeyString, getKey } from "@utils/CommonUtils";
import { FilterDropDown } from "@components/FilterDropDown/FilterDropDown";
import { defaultCurrencyCode, formatToDecimal } from "~/Utils";
import { spaBudget, spaFilterBudget, spaFilterPaper, spaPaper } from "~/Utils/StringConstants";

export const ReviewSPA = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramsObj = Object.fromEntries(searchParams.entries());
  const [data, setData] = useState<any>([]);
  const [apiUrl, setApiUrl] = useState<any>("");
  const { hasRole } = useHasAccess();
  const { openToast } = useNotification();
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setpage] = useState<number>(0);
  const [sortOrder, setSortOrder] = useState("desc");
  const [clearSearch, setClearSearch] = useState<any>(false);
  const [searchString, setSearchString] = useState("");
  const [paperValue, setPaperValue] = useState("");
  const [budgetValue, setBudgetValue] = useState("");
  // const [division, setDivision] = useState<any>("");
  const [amountData, setAmountData] = useState([0, 10000000]);
  // const [subsidiary, setSubsidiary] = useState<any>("");
  const navigate = useNavigate();
  const query = useQuery();
  const [pageStart, setPageStart] = useState<number>(parseInt(query.get("page") || "0") || 0);
  const { user } = useAuth();
  const [orderByName, setOrderByName] = useState("createdOn");
  const { mask } = useMaskId();
  const [status, setStatus] = useState(
    query?.get("status") === "Pending"
      ? "In-Progress"
      : query?.get("status") === "Approved"
      ? "Completed"
      : query?.get("status") !== null && query?.get("status") !== undefined
      ? query?.get("status")
      : ""
  );
  const [overallSatus, setoverallStatus] = useState(
    query?.get("overallStatus") !== null && query?.get("status") !== undefined ? query?.get("overallStatus") : ""
  );
  const startDate =searchParams.get("startDate")
  const endDate =searchParams.get("endDate")
  let budget:any =searchParams.get("budget")
  const paper = searchParams.get("paper");
  const subsidiary =searchParams.get("subsidiary")||''
  const division =searchParams.get("division")||''
  const startAmount:any =searchParams.get("startAmount")
  const endAmount:any =searchParams.get("endAmount")
  const [date, setDate] = useState<any>();
  const [amountRange, setAmountRange] = useState();
  const isActiveTab = query.get("activeTab");
  const decodedBudget = decodeURIComponent(budget)
const encodedBudget = encodeURIComponent(budget)
if (encodedBudget === "OPEX%20" || encodedBudget === "OPEX%20%26%20CAPEX") {
  budget = "OPEX & CAPEX";
}
useEffect(()=>{
setDate({from:startDate,to:endDate})
},[startDate,endDate])

useEffect(()=>{
setAmountData([startAmount,endAmount])
},[startAmount,endAmount])

  useEffect(() => {
    if (hasRole(["*"])) {
      if (!isActiveTab) {
        navigate(`/spa-review?activeTab=pendingReview`, { replace: true });
      } else if (isActiveTab === "reviewed") {
        navigate(`/spa-review?activeTab=reviewed&page=${pageStart}&budget=${budget??""}&paper=${paper??""}&division=${encodeURIComponent(division)|| "" }&subsidiary=${subsidiary|| "" }&startDate=${startDate??""}&endDate=${endDate??""}&startAmount=${startAmount??""}&endAmount=${endAmount??""}`, { replace: true });
      } else if (isActiveTab !== "reviewed") {
        navigate(`/spa-review?activeTab=pendingReview&page=${pageStart}&budget=${budget??""}&paper=${paper??""}&division=${encodeURIComponent(division)|| "" }&subsidiary=${subsidiary|| "" }&startDate=${startDate??""}&endDate=${endDate??""}&startAmount=${startAmount??""}&endAmount=${endAmount??""}`, { replace: true });
      }
    }
  }, [pageStart]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleSearchChange = (value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
  };
  // const overallStatus: any = [
  //   { key: "created", title: "Created" },
  //   { key: "In-Progress", title: "In Progress" },
  //   { key: "completed", title: "Completed" }, //PENDING
  //   { key: "cancelled", title: "Cancelled" }, //PENDING
  //   { key: "rejected", title: "Rejected" }, //PENDING
  //   { key: "expired", title: "Expired" }, //PENDING
  //   { key: "draft", title: "Draft" },
  // ];

  const pendingApprovalStatus: any = [
    { key: "created", title: "Created" },
    { key: "In-Progress", title: "In Progress" },
  ];

  const approvedStatus: any = [
    { key: "In-Progress", title: "In Progress" },
    { key: "completed", title: "Completed" },
    { key: "cancelled", title: "Cancelled" },
    { key: "rejected", title: "Rejected" },
    { key: "expired", title: "Expired" },
  ];

  const dashboardSubsidiary = query?.get("subsidiary") && query?.get("subsidiary");
  const dashboardDivision = query?.get("division") && query?.get("division");
  const dashboardAmount = query?.get("amount") && query?.get("amount");
  const dashboardFromdate = query?.get("dateFrom") && query?.get("dateFrom");
  const dashboardTodate = query?.get("dateTo") && query?.get("dateTo");

  useEffect(() => {
    if (dashboardSubsidiary || dashboardDivision || dashboardAmount || dashboardFromdate || dashboardTodate) {
      // setSubsidiary(dashboardSubsidiary);
      // setDivision(paramDivision);
      // setDate({ from: dashboardFromdate, to: dashboardTodate });
      const formattedItems = Array.of(dashboardAmount)??"";
      const separateItems = formattedItems.map((item: any) => item?.split(","));
      // setAmountData(separateItems.flat(2));
    }
  }, []);

  const handleOverallStatusChange = (value: any) => {
    if (value === undefined) {
      setoverallStatus("");
      query.delete("overallStatus");
    } else {
      setoverallStatus(value);
      query.set("overallStatus", value);
    }
    navigate({ search: query.toString() }, { replace: true });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setClearSearch(false);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [isLoading]);

  const handleTableSort = (column: any, sortOrder: string, page: any) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getRecords(order, column.dataIndex, searchString, pageStart);
  };

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    let url = "";
    if (query.get("activeTab") == "reviewed") {
      url = `v1/spa/approve/list?&page=${currentPage}&division=${encodeURIComponent(division)}&size=${recordsPerPage}&order=${sortOrder}&isCompleted=true&orderBy=${
        orderByParam === "overallStatus"
          ? "overallstatusfilter"
          : orderByParam === "completedDate"
          ? "completionDate"
          : orderByParam
      }&subsidiary=${subsidiary}&status=${status}&startDate=${
        date?.from ? date.from : ""
      }&startAmount=${amountData[0]??""}&endAmount=${amountData[1]??""}&endDate=${
        date?.to ? date.to : ""
      }&overallStatusFilter=${overallSatus}&searchText=${encodeURIComponent(
        searchString
      )}&awardAndStrategyPaper=${paper??''}&budget=${encodeURIComponent(budget??"")}`;
    } else {
      url = `v1/spa/approve/list?isCompleted=false&page=${currentPage}&size=${recordsPerPage}&order=${sortOrder}&division=${encodeURIComponent(division)}&isCompleted=false&orderBy=${
        orderByParam === "overallStatus"
          ? "overallstatusfilter"
          : orderByParam === "completedDate"
          ? "completionDate"
          : orderByParam
      }&subsidiary=${subsidiary}&status=${status}&startDate=${
        date?.from ? date.from : ""
      }&startAmount=${amountData[0]??""}&endAmount=${amountData[1]??''}&endDate=${
        date?.to ? date.to : ""
      }&overallStatusFilter=${overallSatus}&searchText=${encodeURIComponent(
        searchString
      )}&awardAndStrategyPaper=${paper??''}&budget=${encodeURIComponent(budget??"")}`;
    }
    setApiUrl(url);
    get(url)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          setTotalRecords(res.response.data.totalCount);
          let envelopes = res.response.data.records;
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        openToast({
          content: "Getting Contracts failed",
          type: "error",
        });
        setIsLoading(false);
      });
  };
  const [isInitialRender, setIsInitialRender] = useState(true);

  const fetchDate = useCallback(() => {
    return !!(date && date.to && date.from);
  }, [date]);

  useEffect(() => {
    const activeTab = query.get("activeTab");
    const activePage: any = query.get("page");
    if (isInitialRender) {
      setIsInitialRender(false);
      getRecords(sortOrder, orderByName, searchString, searchString.length > 0 ? 0 : pageStart);
    } else if (activeTab) {
      setPageStart(0);
      getRecords(sortOrder, orderByName, searchString, searchString.length > 0 ? 0 : pageStart);
    } else if (activeTab || activePage) {
      setPageStart(activePage);
    }
  }, [
    query.get("activeTab"),
    // paperValue,
    startAmount,
    endAmount,
    paper,
    budget,
    date,
    startDate,
    endDate,
    // budgetValue,
    searchString,
    overallSatus,
    subsidiary,
    division,
    amountData[0],
    amountData[1],
    // fetchDate(),
  ]);

  const columns: TableColumnsType = [
    {
      title: "Project ID",
      dataIndex: "projectId",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectId"
          ? "descend"
          : undefined,
    },
    {
      title: "Project Name",
      dataIndex: "projectTitle",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectTitle"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectTitle"
          ? "descend"
          : undefined,
    },
    {
      title: "Budget",
      dataIndex: "budget",
      render: (value: any) => value || <Typography.Text>Uncategorized</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "budget"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "budget"
          ? "descend"
          : undefined,
    },
    {
      title: "SPA Types",
      dataIndex: "awardAndStrategyPaper",
      render: (value: any) => value || <Typography.Text>Uncategorized</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "awardAndStrategyPaper"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "awardAndStrategyPaper"
          ? "descend"
          : undefined,
    },
    {
      title: "Proposed Contract Value",
      dataIndex: "contractValue",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractValue"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractValue"
          ? "descend"
          : undefined,
    },
    {
      title: "Budget/PTE",
      dataIndex: "amount",
      render: (value: any, record: any) => value && formatToDecimal(value, record?.currencyCode || defaultCurrencyCode),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "amount"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "amount"
          ? "descend"
          : undefined,
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
          ? "descend"
          : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
          ? "descend"
          : undefined,
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "vendorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "vendorName"
          ? "descend"
          : undefined,
    },
    {
      title: "Owner Email",
      dataIndex: "ownerEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "vendorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "vendorName"
          ? "descend"
          : undefined,
    },
    {
      title: "Approver Status",
      dataIndex: "status",
      render: (value: any) => getColoriezedValue(value) || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "status"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "status"
          ? "descend"
          : undefined,
    },
    {
      title: "SPA Status",
      dataIndex: "overallStatus",
      render: (value: any) => getColoriezedValue(value) || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "overallStatus"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "overallStatus"
          ? "descend"
          : undefined,
    },
    {
      title: "Created At",
      dataIndex: "createdOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdOn"
          ? "descend"
          : undefined,
    },
  ];
  const approvedColumns: TableColumnsType = [
    {
      title: "Project ID",
      dataIndex: "projectId",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectId"
          ? "descend"
          : undefined,
    },
    {
      title: "Project Name",
      dataIndex: "projectTitle",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "projectTitle"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "projectTitle"
          ? "descend"
          : undefined,
    },
    {
      title: "Budget",
      dataIndex: "budget",
      render: (value: any) => value || <Typography.Text >Uncategorized</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "budget"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "budget"
          ? "descend"
          : undefined,
    },
    {
      title: "SPA Types",
      dataIndex: "awardAndStrategyPaper",
      render: (value: any) => value || <Typography.Text >Uncategorized</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "awardAndStrategyPaper"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "awardAndStrategyPaper"
          ? "descend"
          : undefined,
    },
    {
      title: "Proposed Contract Value",
      dataIndex: "contractValue",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "contractValue"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "contractValue"
          ? "descend"
          : undefined,
    },
    {
      title: "Budget/PTE",
      dataIndex: "amount",
      render: (value: any, record: any) => value && formatToDecimal(value, record?.currencyCode || defaultCurrencyCode),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "amount"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "amount"
          ? "descend"
          : undefined,
    },
    {
      title: "Subsidiary / Division",
      dataIndex: "subsidiary",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subsidiary"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subsidiary"
          ? "descend"
          : undefined,
    },
    {
      title: "Cost Centre",
      dataIndex: "division",
      render: (value: any, record: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "division"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "division"
          ? "descend"
          : undefined,
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "vendorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "vendorName"
          ? "descend"
          : undefined,
    },
    {
      title: "Owner Email",
      dataIndex: "ownerEmail",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "vendorName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "vendorName"
          ? "descend"
          : undefined,
    },
    {
      title: "SPA Status",
      dataIndex: "overallStatus",
      render: (value: any) => getColoriezedValue(value) || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "overallStatus"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "overallStatus"
          ? "descend"
          : undefined,
    },
    {
      title: "Created At",
      dataIndex: "createdOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "createdOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "createdOn"
          ? "descend"
          : undefined,
    },
    {
      title: "Completed At",
      dataIndex: "completedDate",
      render: (value: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
      ellipsis: true,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "completedDate"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "completedDate"
          ? "descend"
          : undefined,
    },
  ];

  const items = [
    {
      label: "Pending for Approval",
      key: "pendingReview",
      children: (
        <>
          <DataTable
            isMobile={isMobile}
            columns={columns?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            exportFileName="SPA"
            onClick={(record) => {
              getUrlwithParams();
              navigate(`/spa-review/view/${record.envelopeId}`);
            }}
            additionalCTA={
              <FilterDropDown
                isMobile={isMobile}
                setpage={setPageStart}
                viewStatus={false}
                // setSubsidiary={setSubsidiary}
                viewDate={true}
                viewSubsidiary={false}
                clearSearchData={clearSearch}
                viewDivisions={true}
                viewBudget={true}
                viewPaper
                setStatus={setStatus}
                // setDivision={setDivision}
                // setAmountData={setAmountData}
                // setDate={setDate}
                setAmountRange={setAmountRange}
              />
            }
            totalRecords={totalRecords}
            inputDisable={isLoading}
            isPagination={true}
            clearStringSearch={clearSearch}
            spaSearch={true}
            // isServerSearchApi={true}
            // spaSearch={true}
            // onSearchChange={handleSearchChange}
            searchPlaceholderText={"Search Contract ID/Name/Number"}
            exportApiUrl={apiUrl}
            recordsPerPage={recordsPerPage}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={pageStart}
              current={pageStart + 1}
              total={totalRecords}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
    {
      label: "Approved",
      key: "reviewed",
      children: (
        <>
          <DataTable
            isMobile={isMobile}
            columns={approvedColumns?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            onSearchChange={handleSearchChange}
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            isLoading={false}
            inputDisable={isLoading}
            isServerSearchApi={true}
            clearStringSearch={clearSearch}
            additionalCTA={
              <FilterDropDown
                isMobile={isMobile}
                setpage={setPageStart}
                viewStatus={false}
                // setSubsidiary={setSubsidiary}
                viewDate={true}
                viewSubsidiary={false}
                viewDivisions={true}
                viewBudget={true}
                viewPaper
                setStatus={setStatus}
                clearSearchData={clearSearch}
                // setDivision={setDivision}
                // setAmountData={setAmountData}
                // setDate={setDate}
                setAmountRange={setAmountRange}
              />
            }
            exportFileName="SPA"
            onClick={(record) => {
              getUrlwithParams();
              navigate(`/spa-review/view/${record.envelopeId}`);
            }}
            totalRecords={totalRecords}
            isPagination={true}
            searchPlaceholderText={"Search Contract ID/Name/Number"}
            exportApiUrl={apiUrl}
            spaSearch={true}
            recordsPerPage={recordsPerPage}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={pageStart}
              total={totalRecords}
              current={pageStart + 1}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </>
      ),
    },
  ];

  return (
    <ContentWrapper
      isMobile={isMobile}
      className="spa-container"
      title={"Single Party Approval"}
      actionItems={
        hasRole(["SPA_ADMIN", "SPA_APPROVER"]) && (
          <Row
            // style={{ marginRight: "20px" }}
            gutter={12}
            justify="end"
            style={isMobile?{gap:10}:undefined}
          >
            <Col xl={10}
            lg={4}
            md={12}
            sm={18}
            xs={24} span={10}>
              {" "}
              <Input
                allowClear
                title=" Search Project ID / Project Name"
                placeholder=" Search Project ID / Project Name"
                value={searchString}
                onChange={(e) => handleSearchChange(e.target.value, true)}
              />
            </Col>
            <Col xl={5}
            lg={4}
            md={12}
            sm={18}
            xs={24} span={5}>
              <Tooltip title="Select Budget">
                <Select
                  className="w-100"
                  placeholder="Select Budget"
                  allowClear
                  value={budget||undefined}
                  onChange={(e) => {
                    if (e) {
                      // setBudgetValue(e);
                      setSearchParams({ ...paramsObj, "budget":e});
                    } else {
                      // setBudgetValue("");
                      setSearchParams({ ...paramsObj, "budget":""});
                    }
                  }}
                >
                  {spaFilterBudget.map((item: any, i: any) => (
                    <Select.Option
                      value={item}
                      key={i}
                    >
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Tooltip>
            </Col>
            <Col xl={5}
            lg={4}
            md={12}
            sm={18}
            xs={24} span={5}>
              <Tooltip title="Select SPA Types">
                <Select
                  className="w-100"
                  placeholder="Select SPA Types"
                  allowClear
                  value={paper||undefined}
                  onChange={(e) => {
                    if (e) {
                      // setPaperValue(e);
                      setSearchParams({ ...paramsObj, "paper":e});
                    } else {
                      // setPaperValue("");
                      setSearchParams({ ...paramsObj, "paper":''});
                    }
                  }}
                >
                  {spaFilterPaper.map((item: any, i: any) => (
                    <Select.Option
                      value={item}
                      key={i}
                    >
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Tooltip>
            </Col>
            <Col xl={4}
            lg={4}
            md={12}
            sm={18}
            xs={24} span={4}>
              <Tooltip title="Select Overall Status">
                <Select
                  className="w-100"
                  value={overallSatus === "" ? undefined : overallSatus}
                  onChange={handleOverallStatusChange}
                  placeholder="Select Overall Status"
                  allowClear
                >
                  {(isActiveTab == "pendingReview" ? pendingApprovalStatus : approvedStatus).map(
                    (item: any, index: any) => (
                      <Select.Option
                        key={index}
                        value={item.key}
                      >
                        {item.title}
                      </Select.Option>
                    )
                  )}
                </Select>
              </Tooltip>
            </Col>
          </Row>
        )
      }
    >
      {isLoading && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      {hasRole(["*"]) ? (
        <Tabs
          activeKey={query?.get("activeTab") || ""}
          items={items}
          onChange={(activeKey) => {
            setOrderByName("createdOn");
            // setPageStart(0);
            setpage(0);
            setStatus("");
            setSearchString("");
            setClearSearch(true);
            setoverallStatus("");
            // setDivision("");
            // setDate(null);
            navigate(`/spa-review?activeTab=${activeKey}`);
          }}
        ></Tabs>
      ) : (
        <div>
          <DataTable
            isMobile={isMobile}
            columns={columns?.map((column) => ({
              ...column,
              onHeaderCell: (column: any) => ({
                onClick: () => {
                  if (column.sorter) {
                    handleTableSort(column, sortOrder, page ? page : 0);
                  }
                },
              }),
            }))}
            className="table-clickable"
            tableData={
              data
                ? data?.map((d: any, index: number) => {
                    return {
                      ...d,
                      key: getKey(page, index),
                    };
                  })
                : null
            }
            additionalCTA={
              <FilterDropDown
                isMobile={isMobile}
                setpage={setPageStart}
                viewStatus={false}
                // setSubsidiary={setSubsidiary}
                viewDate={true}
                viewSubsidiary={false}
                clearSearchData={clearSearch}
                viewDivisions={true}
                viewBudget={true}
                viewPaper
                setStatus={setStatus}
                // setDivision={setDivision}
                // setAmountData={setAmountData}
                // setDate={setDate}
                setAmountRange={setAmountRange}
              />
            }
            isLoading={false}
            exportFileName="SPA"
            onClick={(record) => {
              getUrlwithParams();
              navigate(`/spa-review/view/${record.envelopeId}`);
            }}
            isPagination={true}
            // onSearchChange={handleSearchChange}
            inputDisable={isLoading}
            spaSearch={true}
            isServerSearchApi={true}
            totalRecords={totalRecords}
            exportApiUrl={apiUrl}
            clearStringSearch={clearSearch}
            recordsPerPage={recordsPerPage}
            searchPlaceholderText={"Search here"}
            tabOffset={80}
          />
          <div className="pagination">
            <Pagination
              defaultCurrent={1}
              total={totalRecords}
              current={page + 1}
              onChange={(page) => {
                const pageSize = 10;
                const startIndex = page - 1;
                setpage(page - 1);
                setPageStart(startIndex);
                getRecords(sortOrder, orderByName, searchString, startIndex);
              }}
              showSizeChanger={false}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
};
